<template>
  <div>
    <div :id="id"></div>
  </div>
</template>

<script>
import Qs from 'qs'

// 引入基本模板
let echarts = require("echarts/lib/echarts");
// 引入柱状图组件
require("echarts/lib/chart/bar");
require("echarts/lib/chart/gauge");
// 引入提示框和title组件
require("echarts/lib/component/tooltip");
require("echarts/lib/component/title");
// 不引入这个会报错 xAxis "0" not found
require("echarts/lib/component/grid");
// import 'echarts/lib/component/grid';
import {LegendComponent} from 'echarts/components';

echarts.use([LegendComponent]);
import {ToolboxComponent} from 'echarts/components';

echarts.use([ToolboxComponent]);
export default {
  name: "Ranking",
  props: {
    id: {
      type: String,
      default: "chart1",
    },
    voteID: {
      type: String,
      default: ""
    }
  },
  data() {
    return {
      chartOption: {},
      iShowDetails: false,
      dtDetails: [],
      isLoading: false,
      height: 0,
      width: 950
    };
  },
  mounted() {
    this.chartOption = {};
    this.getChartOption();
  },
  methods: {
    getChartOption() {

      this.$api.voteAPI.getChartData(Qs.stringify({voteID: this.voteID}))
        .then(res => {
          if (res.data.Success == false) {
            console.log(res.data.Message);
            return;
          }
          let yData = res.data.Data.developer;
          let data = res.data.Data.ct;
          debugger
          if (yData.length > 0) {
            this.setHeight(35 * yData.length + 50);
          }

          this.chartOption = {
            grid: {
              left: '3%',
              right: '4%',
              bottom: '3%',
              containLabel: true
            },
            xAxis: {
              type: 'value'
            },
            yAxis: {
              type: 'category',
              inverse: true,
              data: yData

            },
            series: {
              data: data,
              type: 'bar',
              label: {
                show: true
              },
              itemStyle: {
                color: '#91CC75'
              }
            }
          };
          this.drawLine();

        })
        .catch(error => {
          console.log(error);
        })
    },
    drawLine() {
      // 基于准备好的dom，初始化echarts实例
      console.log(this.id);
      let myChart = echarts.init(document.getElementById(this.id));
      // 绘制图表
      myChart.setOption(this.chartOption);
      myChart.resize({height: this.height, width: this.width});
      // 设置表格的点击事件进行路由的切换
      myChart.on(
        "click",
        (param) => {
          //  this.iShowDetails = true;
          // this.dtDetails = [];
          //  this.isLoading = true;
          // this.getChartDetail(param.name, param.seriesName);
          //alert(param.name + ";" + param.seriesName);
        },
      );

    },
    setHeight(h) {
      this.height = h;
    }
  },
};
</script>

<style scoped>

</style>
